/**
 * Video Library - Video Modal & Carousel Functionality
 */

document.addEventListener( 'DOMContentLoaded', function() {
	const videoCards = document.querySelectorAll( '.video-card' );

	// Initialize carousels
	initCarousels();

	if ( videoCards.length === 0 ) {
		return;
	}

	// Create modal element
	const modal = document.createElement( 'div' );
	modal.className = 'video-modal';
	modal.innerHTML = `
		<div class="video-modal-overlay"></div>
		<div class="video-modal-content">
			<button class="video-modal-close">&times;</button>
			<div class="video-modal-iframe-wrapper">
				<iframe
					src=""
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen>
				</iframe>
			</div>
		</div>
	`;
	document.body.appendChild( modal );

	const modalOverlay = modal.querySelector( '.video-modal-overlay' );
	const modalClose = modal.querySelector( '.video-modal-close' );
	const modalIframe = modal.querySelector( 'iframe' );

	// Function to get YouTube embed URL
	function getYouTubeEmbedUrl( url ) {
		if ( !url ) {return '';}

		// Handle different YouTube URL formats
		let videoId = '';

		// Format: https://www.youtube.com/watch?v=VIDEO_ID
		if ( url.includes( 'youtube.com/watch' ) ) {
			const urlParams = new URLSearchParams( url.split( '?' )[1] );
			videoId = urlParams.get( 'v' );
		}
		// Format: https://youtu.be/VIDEO_ID
		else if ( url.includes( 'youtu.be/' ) ) {
			videoId = url.split( 'youtu.be/' )[1].split( '?' )[0];
		}
		// Format: https://www.youtube.com/embed/VIDEO_ID
		else if ( url.includes( 'youtube.com/embed/' ) ) {
			return url;
		}

		return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : '';
	}

	// Open modal
	function openModal( videoUrl ) {
		const embedUrl = getYouTubeEmbedUrl( videoUrl );
		if ( embedUrl ) {
			modalIframe.src = embedUrl;
			modal.classList.add( 'active' );
			document.body.style.overflow = 'hidden';
		}
	}

	// Close modal
	function closeModal() {
		modalIframe.src = '';
		modal.classList.remove( 'active' );
		document.body.style.overflow = '';
	}

	// Add click event to video cards
	videoCards.forEach( card => {
		card.addEventListener( 'click', function() {
			const videoUrl = this.getAttribute( 'data-video-url' );
			if ( videoUrl ) {
				openModal( videoUrl );
			} else {
				console.warn( 'No video URL found. Add data-video-url attribute to video card.' );
			}
		} );
	} );

	// Close modal events
	modalClose.addEventListener( 'click', closeModal );
	modalOverlay.addEventListener( 'click', closeModal );

	// Close on Escape key
	document.addEventListener( 'keydown', function( e ) {
		if ( e.key === 'Escape' && modal.classList.contains( 'active' ) ) {
			closeModal();
		}
	} );

	/**
	 * Initialize video carousels
	 */
	function initCarousels() {
		const carouselSections = document.querySelectorAll( '.video-category-section.has-carousel' );

		carouselSections.forEach( section => {
			const carousel = section.querySelector( '.videos-carousel' );
			const prevBtn = section.querySelector( '.carousel-prev' );
			const nextBtn = section.querySelector( '.carousel-next' );

			if ( !carousel || !prevBtn || !nextBtn ) {
				return;
			}

			let currentIndex = 0;
			const cards = carousel.querySelectorAll( '.video-card' );
			const totalCards = cards.length;

			// Get visible cards count based on screen width
			function getVisibleCount() {
				if ( window.innerWidth <= 768 ) {
					return 1;
				} else if ( window.innerWidth <= 1024 ) {
					return 2;
				}
				return 3;
			}

			// Update carousel position
			function updateCarousel() {
				const visibleCount = getVisibleCount();
				const maxIndex = Math.max( 0, totalCards - visibleCount );
				currentIndex = Math.min( currentIndex, maxIndex );

				const cardWidth = cards[0].offsetWidth;
				const gap = 30;
				const offset = currentIndex * ( cardWidth + gap );

				carousel.style.transform = `translateX(-${offset}px)`;

				// Update button states
				prevBtn.disabled = currentIndex === 0;
				nextBtn.disabled = currentIndex >= maxIndex;
			}

			// Event listeners - scroll by visible count (3 on desktop, 2 on tablet, 1 on mobile)
			prevBtn.addEventListener( 'click', function() {
				const visibleCount = getVisibleCount();
				if ( currentIndex > 0 ) {
					currentIndex = Math.max( 0, currentIndex - visibleCount );
					updateCarousel();
				}
			} );

			nextBtn.addEventListener( 'click', function() {
				const visibleCount = getVisibleCount();
				const maxIndex = Math.max( 0, totalCards - visibleCount );
				if ( currentIndex < maxIndex ) {
					currentIndex = Math.min( maxIndex, currentIndex + visibleCount );
					updateCarousel();
				}
			} );

			// Handle resize
			let resizeTimeout;
			window.addEventListener( 'resize', function() {
				clearTimeout( resizeTimeout );
				resizeTimeout = setTimeout( updateCarousel, 100 );
			} );

			// Initial state
			updateCarousel();
		} );
	}
} );
